import { BookSection } from '@Models';
import {
  buildEntityActionState,
  EntityActionState,
} from '../EntityActionState';

export type BookSectionState = EntityActionState<BookSection>;

export const buildBookSectionState = (data: Partial<BookSectionState> = {}) =>
  buildEntityActionState<BookSection>(data);
